import React, { Fragment } from "react";
import {NavLink} from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import {LinkContainer} from "react-router-bootstrap";

const  navBar = (props) => (
    <Fragment>
       <Navbar bg="dark"  variant="dark" expand="lg">
            <Navbar.Brand href="#">RIADH-NSIRI</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav"  />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                    <LinkContainer exact to="/">
                        <Nav.Link>Accueil</Nav.Link>
                    </LinkContainer>
                    <LinkContainer exact to="/localisation">
                        <Nav.Link>Toute la France</Nav.Link>
                    </LinkContainer>
                    <LinkContainer exact to="/localisation75">
                        <Nav.Link >75</Nav.Link>
                    </LinkContainer>
                    <LinkContainer exact to="/localisation77">
                        <Nav.Link>77</Nav.Link>
                    </LinkContainer>
                    <LinkContainer exact to="/localisation78">
                        <Nav.Link>78</Nav.Link>
                    </LinkContainer>
                    <LinkContainer exact to="/localisation91">
                        <Nav.Link>91</Nav.Link>
                    </LinkContainer>
                    <LinkContainer exact to="/localisation92">
                        <Nav.Link>92</Nav.Link>
                    </LinkContainer>
                    <LinkContainer exact to="/localisation93">
                        <Nav.Link>93</Nav.Link>
                    </LinkContainer>
                    <LinkContainer exact to="/localisation94">
                        <Nav.Link>94</Nav.Link>
                    </LinkContainer>
                    <LinkContainer exact to="/localisation95">
                        <Nav.Link>95</Nav.Link>
                    </LinkContainer>
                    <LinkContainer exact to="/contact">
                        <Nav.Link>Contact</Nav.Link>
                    </LinkContainer>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    </Fragment>
);

export default navBar;